import { render, staticRenderFns } from "./ProductSoldByCategoryPage.vue?vue&type=template&id=14518b9c&scoped=true"
import script from "./ProductSoldByCategoryPage.vue?vue&type=script&lang=js"
export * from "./ProductSoldByCategoryPage.vue?vue&type=script&lang=js"
import style0 from "./ProductSoldByCategoryPage.vue?vue&type=style&index=0&id=14518b9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14518b9c",
  null
  
)

export default component.exports